export const paymentModeAr = {
  "Donner le Nom": "أعط الاسم",
  "Code": "الرقم",
  "Donner le Code": "أعط الرقم",

  // server Side  

  "La methode deja existe.": "طريقة الدفع موجودة بالفعل.",
  "le nom est obligatoire.": "الاسم مطلوب.",
  "le code est obligatoire.": "الرمز مطلوب.",
  

}